// extracted by mini-css-extract-plugin
export default {"inputFieldLength":"ChangePasswordPage_inputFieldLength__9EmOD"};